import { Tooltip } from '@material-ui/core';

export const TableName = ({ label, tooltip }) => (
  <Tooltip title={tooltip}>
    <td>{label}</td>
  </Tooltip>
);
